import { gql } from '@apollo/client';

export const CREATE_SOIL_MONITOR = gql`
    mutation CreateSoilMonitor($input: CreateSoilMonitor!) {
        facility {
            process {
                createSoilMonitor(input: $input) {
                    id
                }
            }
        }
    }
`;
